import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    background: theme.palette.primary.main,
    width: "100%",
  },
  tableRow: {
    width: "100%",
  },
  shotVersionTableCell: {
    padding: "10px 0px",
    color: `${theme.palette.text.tertiary} !important`,
    backgroundColor: `${theme.palette.primary.main} !important`,
    zIndex: "3",
    width: "16% !important",
    borderBottom: `1px solid ${theme.palette.text.tertiary} !important`,
    borderTop: `1px solid ${theme.palette.text.tertiary} !important`,
  },
  shotVersionTableCellTwo: {
    padding: "10px 0px",
    color: `${theme.palette.text.tertiary} !important`,
    backgroundColor: `${theme.palette.primary.main} !important`,
    zIndex: "3",
    width: "12% !important",
    borderBottom: `1px solid ${theme.palette.text.tertiary} !important`,
    borderTop: `1px solid ${theme.palette.text.tertiary} !important`,
  },
}));

export default useStyles;
